import { graphql } from 'gatsby'

import Layout from '../../components/layout'
import Seo from '../../components/seo'
import MagazineHero from '../../components/MagazineHero';
import MagazineGrid from '../../components/MagazineGrid';
import MagazineCategories from '../../components/MagazineCategories';
import FollowUs from '../../components/FollowUs';

const MagazinePage = ({data}) => (
    <Layout footerColor='bg-gray' bgColor='bg-white'>
      <Seo title="Magazine" />
      <div className="bg-white">
        <MagazineHero mostRecentArticle={data.mostRecentArticle}/>
        <MagazineGrid />
      </div>
      <MagazineCategories />
      <FollowUs />
    </Layout>
  )

export default MagazinePage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    mostRecentArticle: allMagazine(limit: 1, sort: {title: ASC}) {
      edges {
        node {
          title
          subTitle
          topText
          slug
          createdAt
        }
      }
    }
  }
`
